import axios from 'axios';

export const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

apiClient.interceptors.request.use(
    config => {
        const token = localStorage.getItem('access_token');
        if (token && config.headers) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

export const authenticate = async (username, password) => {
    const formData = new FormData();
    formData.append('email', username);
    formData.append('password', password);

    const response = await apiClient.post('/auth/admin/login', formData, {
        body: {
            email: username,
            password
        }
    });
    return response.data;
};